import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Map } from 'immutable';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import styles from './style.scss';
import { WIDGET_LOCALE } from '../../locale-wrapper';
import { DateTimeDisplay } from './date-time-display';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  format: PropTypes.string,
  className: PropTypes.string,
};

const FRENCH_LANGUAGE_MAPPING = {
  'Do MMM': 'MMM Do',
  'Do MMMM': 'MMMM Do',
  'Do MMMM YYYY': 'MMMM Do YYYY',
  'ddd Do MMMM': 'ddd MMMM Do',
  'ddd Do MMMM YYYY': 'ddd MMMM Do YYYY',
  'dddd Do MMMM YYYY': 'dddd MMMM Do YYYY',
  'dDDD Do MMMM YYYY': 'dDDD MMMM Do YYYY',
};

const DATE_TO_FRENCH_LANGUAGE_MAPPING = {
  // fr: FRENCH_LANGUAGE_MAPPING,
};

const getFormat = (format, locale = 'en') => {
  const mapping = DATE_TO_FRENCH_LANGUAGE_MAPPING[locale];
  if (!mapping) return format;
  const mappedFormat = FRENCH_LANGUAGE_MAPPING[format];
  if (!mappedFormat) return format;

  return mappedFormat;
};
function Time({ event, settings, format, className = '' }) {
  const dateTBD = event.get('date_tbd');
  if (dateTBD) return <span />;
  const startTime = event.getIn(['date', 'start', 'utc']);
  const endTime = event.getIn(['date', 'end', 'utc']);
  const allDay = event.get('all_day_event');
  const timeZone = settings.get('automaticTimezone') ? moment.tz.guess() : event.getIn(['date', 'start', 'timezone']);

  const isMobile = window.isMobileType;

  let momentStartTime = moment(startTime);
  let momentEndTime = moment(endTime);
  if (startTime && timeZone) {
    momentStartTime = moment(startTime).tz(timeZone);
    momentEndTime = moment(endTime).tz(timeZone);
  } else {
    momentStartTime = moment(startTime).utc();
    momentEndTime = moment(endTime).utc();
  }

  const locale = event.get('type') === 'eventviewer' ? WIDGET_LOCALE : event.get('locale', 'en').split('_')[0];

  const momentStartLocale = momentStartTime.locale(locale);
  const momentEndLocale = momentEndTime.locale(locale);

  const timezone = settings.get('includeTimezone') ? ' z' : '';

  const dateFormat = locale === 'it' ? settings.get('dateFormat').replace('o', '') : getFormat(settings.get('dateFormat'), locale);

  const date = (
    <DateTimeDisplay
      settings={settings}
      event={event}
      showStart={settings.get('showStartDate', false)}
      showEnd={settings.get('showEndDate', false)}
      momentStartLocale={momentStartLocale}
      momentEndLocale={momentEndLocale}
      format={format || dateFormat}
      className={className}
    />
  );

  const time = (
    <DateTimeDisplay
      settings={settings}
      event={event}
      showStart={allDay ? false : settings.get('showTime', false)}
      showEnd={allDay ? false : settings.get('showEndTime', false)}
      momentStartLocale={momentStartLocale}
      momentEndLocale={momentEndLocale}
      format={`${settings.get('timeFormat')} ${timezone}`}
      className={className}
    />
  );

  const direction = isMobile ? { 'flex-direction': 'column' } : {};

  return (
    <div className={cn('date', className)}>
      {event.get('is_recurring') && settings.get('nextEventText') && (
        <span className={cn('recurring-next-events', styles.nextEvent)}>
          {settings.get('autoTranslateEvent') ? (
            <span>
              <FormattedMessage id="next-event" defaultMessage="Next Event" />:
            </span>
          ) : (
            <span>{settings.get('nextEventText')}</span>
          )}
        </span>
      )}
      <div style={{ display: 'flex', ...direction, justifyContent: 'center' }} className="first">
        {date}
      </div>
      <div style={{ display: 'flex' }} className={className}>
        {time}
      </div>
      {/* {event.get('is_recurring') && (
        <span className={cn('recurring-other-dates', styles.otherDates)}>
          {settings.get('otherAvailableDateText')}
        </span>
      )} */}
    </div>
  );
}

Time.propTypes = propTypes;

export default Time;
